// Primary
import PrimaryWhite from "../../static/img/brand/primary/primary-white.svg";
import PrimaryBlue from "../../static/img/brand/primary/primary-blue.svg";
import PrimaryBlack from "../../static/img/brand/primary/primary-black.svg";
import PrimaryWhitePNG from "../../static/img/brand/primary/primary-white.png";
import PrimaryBluePNG from "../../static/img/brand/primary/primary-blue.png";
import PrimaryBlackPNG from "../../static/img/brand/primary/primary-black.png";
// Stacked
import PrimaryStackedWhite from "../../static/img/brand/primary-stacked/primary-stacked-white.svg";
import PrimaryStackedBlue from "../../static/img/brand/primary-stacked/primary-stacked-blue.svg";
import PrimaryStackedBlack from "../../static/img/brand/primary-stacked/primary-stacked-black.svg";
import PrimaryStackedWhitePNG from "../../static/img/brand/primary-stacked/primary-stacked-white.png";
import PrimaryStackedBluePNG from "../../static/img/brand/primary-stacked/primary-stacked-blue.png";
import PrimaryStackedBlackPNG from "../../static/img/brand/primary-stacked/primary-stacked-black.png";
// Logomarks
import LogomarkWhite from "../../static/img/brand/logomark/logomark-white.svg";
import LogomarkBlue from "../../static/img/brand/logomark/logomark-blue.svg";
import LogomarkBlack from "../../static/img/brand/logomark/logomark-black.svg";
import LogomarkWhitePNG from "../../static/img/brand/logomark/logomark-white.png";
import LogomarkBluePNG from "../../static/img/brand/logomark/logomark-blue.png";
import LogomarkBlackPNG from "../../static/img/brand/logomark/logomark-black.png";
// Tracer DAO logos
import TracerDAOWhite from "../../static/img/brand/tracer-dao/tracer-dao-white.svg";
import TracerDAOBlue from "../../static/img/brand/tracer-dao/tracer-dao-blue.svg";
import TracerDAOBlack from "../../static/img/brand/tracer-dao/tracer-dao-black.svg";
import TracerDAOWhitePNG from "../../static/img/brand/tracer-dao/tracer-dao-white.png";
import TracerDAOBluePNG from "../../static/img/brand/tracer-dao/tracer-dao-blue.png";
import TracerDAOBlackPNG from "../../static/img/brand/tracer-dao/tracer-dao-black.png";
// Graphics
import MeshHorizontal from "../../static/img/brand/graphics/mesh-bg-horizontal.png";
import MeshVertical from "../../static/img/brand/graphics/mesh-bg-vertical.png";
import MeshFull from "../../static/img/brand/graphics/mesh-bg-full.png";
import TracerTileCircle from "../../static/img/brand/graphics/tracer-tile-cir-isometric.png";
import TracerTileSquare from "../../static/img/brand/graphics/tracer-tile-sq-isometric.png";
import MeshHorizontalDL from "../../static/img/brand/graphics/mesh-bg-horizontal-dl.png";
import MeshVerticalDL from "../../static/img/brand/graphics/mesh-bg-vertical-dl.png";
import MeshFullDL from "../../static/img/brand/graphics/mesh-bg-full-dl.png";
import TracerTileCircleDL from "../../static/img/brand/graphics/tracer-tile-cir-isometric-dl.png";
import TracerTileSquareDL from "../../static/img/brand/graphics/tracer-tile-sq-isometric-dl.png";

export const primaryLogos = [
  {
    description: "White",
    svg: PrimaryWhite,
    png: PrimaryWhitePNG,
    logo: true,
  },
  {
    description: "Blue",
    svg: PrimaryBlue,
    png: PrimaryBluePNG,
    logo: true,
  },
  {
    description: "Black",
    svg: PrimaryBlack,
    png: PrimaryBlackPNG,
    logo: true,
  },
];

export const primaryLogosStacked = [
  {
    description: "White",
    svg: PrimaryStackedWhite,
    png: PrimaryStackedWhitePNG,
    logo: true,
  },
  {
    description: "Blue",
    svg: PrimaryStackedBlue,
    png: PrimaryStackedBluePNG,
    logo: true,
  },
  {
    description: "Black",
    svg: PrimaryStackedBlack,
    png: PrimaryStackedBlackPNG,
    logo: true,
  },
];

export const logomarks = [
  {
    description: "White",
    svg: LogomarkWhite,
    png: LogomarkWhitePNG,
    logo: true,
  },
  {
    description: "Blue",
    svg: LogomarkBlue,
    png: LogomarkBluePNG,
    logo: true,
  },
  {
    description: "Black",
    svg: LogomarkBlack,
    png: LogomarkBlackPNG,
    logo: true,
  },
];

export const tracerDAOLogos = [
  {
    description: "White",
    svg: TracerDAOWhite,
    png: TracerDAOWhitePNG,
    logo: true,
  },
  {
    description: "Blue",
    svg: TracerDAOBlue,
    png: TracerDAOBluePNG,
    logo: true,
  },
  {
    description: "Black",
    svg: TracerDAOBlack,
    png: TracerDAOBlackPNG,
    logo: true,
  },
];

export const colours = [
  {
    description: "Primary Blue",
    hex: "#0000b0",
  },
  {
    description: "Primary Cyan",
    hex: "#00d9e9",
  },
  {
    description: "Primary Navy",
    hex: "#00005e",
  },
  {
    description: "Secondary Light Blue",
    hex: "#0094f8",
  },
  {
    description: "Secondary Mid Blue",
    hex: "#3535dc",
  },
  {
    description: "Secondary Pink",
    hex: "#bc7cff",
  },
  {
    description: "Secondary Purple",
    hex: "#7223ff",
  },
];

export const graphics = [
  {
    description: "Mesh Background Horizontal",
    image: MeshHorizontal,
    download: MeshHorizontalDL,
    alt: "Mesh Background Horizontal",
  },
  {
    description: "Mesh Background Vertical",
    image: MeshVertical,
    download: MeshVerticalDL,
    alt: "Mesh Background Vertical",
  },
  {
    description: "Mesh Background Full",
    image: MeshFull,
    download: MeshFullDL,
    alt: "Mesh Background Full",
  },
  {
    description: "Square Isometric Tile",
    image: TracerTileSquare,
    download: TracerTileSquareDL,
    alt: "Square Isometric Tile",
  },
  {
    description: "Circular Isometric Tile",
    image: TracerTileCircle,
    download: TracerTileCircleDL,
    alt: "Circular Isometric Tile",
  },
];
